import * as React from 'react';
import { Box, Container, Grid, Paper, Skeleton, Stack } from '@mui/material';
import HeroSectionSkeleton from '../../../skeletons/HeroSectionSkeleton';

/* =========================
   MAIN HERO SKELEТОН
========================= */
interface HeroSkeletonProps {
  isDark?: boolean;
}

export default function HeroSkeleton({ isDark }: HeroSkeletonProps) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        pt: {
          xs: '96px',
          sm: '136px',
        },
      }}
    >
      <Container maxWidth='lg'>
        <HeroSectionSkeleton isDark />
      </Container>
    </Box>
  );
}
